import { usePageTitle } from '../../hooks/usePageTitle';
import { PlaceholderPage } from '../_shared/PlaceholderPage';

export function ComunicazioniPlaceholderPage() {
  usePageTitle('Comunicazioni');
  return (
    <PlaceholderPage
      title="Comunicazioni"
      subtitle="Email, WhatsApp e promemoria pazienti."
      icon="chat"
    />
  );
}

export default ComunicazioniPlaceholderPage;
